import React, { useEffect, useState, useRef } from "react";
import { Container, Row, UncontrolledAlert } from "reactstrap";
import { useHistory, Redirect } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Breadcrumbs from "../../../../components/UI/Tables/Breadcrumb";
import OrderFilter from "./HeaderFilter";
import Datatable from "../../../../components/UI/Tables/Datatable";

import { ServiceData } from "../../../../helpers/columns";
import Delete_icon from "../../../../assets/icons/ebud-icons/Delete.svg";
import Edit_icon from "../../../../assets/icons/ebud-icons/Edit.svg";
import ConfirmationAlert from "../../../../components/confiramtionAlert";
import Loader from "../../../../components/UI/Loader";

import { getLocalStorage } from "../../../../helpers/utils";
import {
  deleteServiceDetails,
  deleteSlotDetails,
  getServiceDetails,
  getSlotDetails, addServiceDetails
} from "../../../../store/serviceProvider/Clinic/action";
import { get } from "../../../../helpers/api_helpers";

// import Loader from "../../components/Common/Loader";

const Services = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const slot = useSelector((state) => state.Slot);
  const [showPromptPopUp, setShowPromptPopUp] = useState(false);
  const [promptMessage, setPromptMessage] = useState({});
  const [order, setOrder] = useState();
  const [changeValue, setChangeValue] = useState(false);
  const [id, setId] = useState(null);
  const warningAlertRef = useRef(null);
  const pageWrapRef = useRef(null);
  const [servicesDropdown, setServicesDropdown] = useState([]);
  const [selectedService, setSelectedService] = useState("");

  const basicRequest = {
    sort: "time_created",
    sort_order: "desc",
    page: 1,
    page_count: 10,
  };

  const [request, setRequest] = useState({ ...basicRequest });

  useEffect(() => {
    dispatch(getServiceDetails({ request }));
  }, [request]);

  useEffect(() => {
    setRequest({ ...basicRequest });
  }, [history?.location?.state?.from]);

  useEffect(() => {
    const fetchDropdownServices = async () => {
      try {
        const res = await get("/partner/clinic_services_list");
        setServicesDropdown(res?.result?.services || []);
        console.log('checkserviceslist', servicesDropdown);

      } catch (err) {
        console.error("Dropdown API error:", err);
      }
    };

    fetchDropdownServices();
  }, []);

  const auth = getLocalStorage("AUTH_DETAILS");

  const okHandler = () => {
    dispatch(
      deleteServiceDetails({
        data: { service_id: promptMessage.id },
        callback: () => dispatch(getServiceDetails(request)),
      })
    );
  };

  const deletePromptHandler = (id) => {
    setShowPromptPopUp(!showPromptPopUp);
    setPromptMessage({
      id: id,
      title: "",
      content: "Are you sure you want to delete this Service",
      type: "delete",
    });
  };
  console.log('slot', slot);
  const existingServiceIds =
    slot?.Service?.services?.map((s) => s.parent_service_id) || [];
  console.log('existingServiceIds', existingServiceIds);
  console.log('servicesDropdown', servicesDropdown);

  const availableServices = servicesDropdown.filter(
    (s) => !existingServiceIds.includes(s.id)
  );
  console.log('availableServices', availableServices);

  const formatslotData =
    slot?.Service?.services?.length &&
    slot?.Service?.services?.map((service, index) => ({
      no: (request?.page - 1) * request?.page_count + index + 1,
      service: <div title={service.service}>{service.service}</div>,



      actions: (
        <div className="cust-table-actions-wrap ps-5">
          {/* <button
            className=" color-violet action-btn"
            title="Edit"
            onClick={() =>
              history.push(`/carer/clinic/service-edit/${service.service_id}`)
            }
          >
            <img src={Edit_icon} alt="Edit" />
          </button> */}
          <button
            onClick={() => deletePromptHandler(service.service_id)}
            className=" color-red action-btn"
            title="Delete"
          >
            <img src={Delete_icon} alt="Delete" />
          </button>
        </div>
      ),
    }));


  // const addNewClickHandler = () => {
  //   history.push("/carer/clinic/add-service");
  // };
  console.log('formatslotData', formatslotData);

  const handleAddService = () => {
    console.log('selectedService', selectedService);
    if (!selectedService) return;

    dispatch(
      addServiceDetails({
        Service: {
          service_id: selectedService,
          //optional or extend later
        },
        callback: () => {
          setSelectedService("");
          // 🔥 SHOW SUCCESS POPUP
          setPromptMessage({
            title: "Success",
            content: "Service added successfully",
            type: "success", // 👈 important
          });
          setShowPromptPopUp(true);
          dispatch(getServiceDetails(request)); // refresh list
        },
      })
    );
  };

  return !auth?.user?.profile_completed ? (
    <Redirect to="/carer/complete-profile" />
  ) : !auth?.user?.admin_approved ? (
    <Redirect to="/carer/under-verification" />
  ) : (
    <div
      className="page-content cust-page"
      data-testid="component-faqList"
      id="reserveUNList"
      ref={pageWrapRef}
    >
      <Container fluid>
        <Row className="">
          <Breadcrumbs title="Tables" breadcrumbItem="Services" />
          {(slot?.error || slot?.success) && (
            <div>
              <UncontrolledAlert
                color={slot?.error ? "danger" : "success"}
                className="alert-dismissible fade show"
                role="alert"
              >
                {slot?.error || slot?.success}
              </UncontrolledAlert>
            </div>
          )}
          <div className="mb-4 p-3 border rounded  align-items-center">
            <h5 className="mb-3">Add Service</h5>

            <div style={{ display: "flex", alignItems: "center" }}>
              <select
                className="form-control"
                style={{ width: "300px", marginRight: "20px" }}
                value={selectedService}
                onChange={(e) => setSelectedService(e.target.value)}
              >
                <option value="">-- Select Service --</option>
                {availableServices.map((s) => (
                  <option key={s.id || s.service_list_id} value={s.id}>
                    {s.title}
                  </option>
                ))}
              </select>

              <button
                className="btn btn-primary"
                onClick={handleAddService}
                disabled={!selectedService}
              >
                Save
              </button>
            </div>
          </div>
          <Datatable
            defaultSortField={"modified_on"}
            defaultSortAsc={false}
            tableID={"service"}
            rows={formatslotData}
            columns={ServiceData}
            // add
            search
            // addNewClickHandler={addNewClickHandler}
            request={request}
            setRequest={setRequest}
            // searchTerm={productData?.request?.keyword}
            // totalRecords={productData?.data?.total}
            loading={slot?.loading}
            // addNewLabel=" ADD SERVICE"
            tableCardClassName={"snoTable"}
            noPagination
          />
        </Row>
      </Container>

      <ConfirmationAlert
        {...promptMessage}
        modal_center={showPromptPopUp}
        setmodal_center={setShowPromptPopUp}
        onOK={okHandler}
      />
      {slot?.loading && <Loader />}
    </div>
  );
};

export default Services;
